module.exports = __webpack_public_path__ + "media/images/logo-66ec98d8e9a4672c815c62fc1306238c.svg";